(() => {
  const allowed = new Set(['16005236982046','16005241635102','16001611923742','16001621950750']);
  const safeUrl = value => {
    if (typeof value !== 'string' || !value.trim()) return null;
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin) ? url.href : null; } catch { return null; }
  };
  const clean = art => {
    if (!art || !Array.isArray(art.photos) || ![3,5,6,10].includes(art.photos.length)) return null;
    const photos = art.photos.map(photo => ({url:safeUrl(photo.url),frame:Array.isArray(photo.frame)&&photo.frame.length===4&&photo.frame.every(n=>Number.isFinite(n)&&Math.abs(n)<300)?photo.frame:[0,0,100,100]}));
    if (photos.some(photo=>!photo.url)) return null;
    return {image:safeUrl(art.image),photos};
  };
  window.SigSagCartArt = {
    async decorate(item, art) {
      const data=clean(art);
      if (!allowed.has(String(item.product_id)) || !data) return item;
      const response=await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{['sigsag_art_'+item.key]:JSON.stringify(data)}})});
      if (!response.ok) throw new Error('cart_art_failed');
      const cart=await response.json();
      const parent=cart.items.find(candidate=>candidate.key===item.key&&String(candidate.product_id)===String(item.product_id));
      if (!parent || parent.final_price!==item.final_price || parent.quantity!==item.quantity) throw new Error('cart_art_price_mismatch');
      return parent;
    }
  };
  if (customElements.get('sigsag-cart-art')) return;
  customElements.define('sigsag-cart-art',class extends HTMLElement {
    connectedCallback() {
      let art; try {art=clean(JSON.parse(this.dataset.art));}catch{return;}
      if(!art)return;
      const stage=document.createElement('span');stage.className='ssa-art';stage.setAttribute('aria-hidden','true');
      if(art.image){const image=document.createElement('img');image.src=art.image;image.alt='';image.loading='lazy';image.className='ssa-preset';stage.append(image);}
      else art.photos.forEach((photo,index)=>{
        const piece=document.createElement('span');piece.className='ssa-piece';
        const quantity=art.photos.length;const row=quantity===10?Math.floor(index/5):0;const column=quantity===10?index%5:index;
        const width=quantity===10?48:quantity===3?78:67;
        const left=quantity===10?(row===0?14:0)+column*9:quantity===3?18-index*8:quantity===6?31-index*6:29-index*7;
        const top=quantity===10?(row===0?6:22)+column*7:quantity===3?5+index*12:quantity===6?2+index*8:4+index*9;
        Object.assign(piece.style,{width:width+'%',left:left+'%',top:top+'%',zIndex:String(index+1)});
        const frame=document.createElement('span');frame.className='ssa-frame';const image=document.createElement('img');image.src=photo.url;image.alt='';image.loading='lazy';Object.assign(image.style,{left:photo.frame[0]+'%',top:photo.frame[1]+'%',width:photo.frame[2]+'%',height:photo.frame[3]+'%'});frame.append(image);piece.append(frame);stage.append(piece);
      });
      this.replaceChildren(stage);
    }
  });
})();
